import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap'
import { NewBadgeComponent } from './components/newBadge.component'
import { ReleaseNotesModalComponent } from './components/releaseNotesModal.component'

@NgModule({
  imports: [
    CommonModule,
    NgbModalModule,
  ],
  declarations: [
    NewBadgeComponent,
    ReleaseNotesModalComponent,
  ],
  exports: [
    NewBadgeComponent,
    ReleaseNotesModalComponent,
  ],
})
export class UtilReleaseNotesModule { }
